import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Nav2 from '../../Nav2/Nav2';
import BannerPendidikan from '../CategoryBanner/bannerpendidikan';
import Content from '../Content/Content';
import './category.css'




const Pendidikan = () => {
    const [content, setContent] = useState([])

    const fetchPendidikan = async () => {
        const { data } = await axios.get(
            'https://weshare-heroku.herokuapp.com/api/weShare/category/'
        )
        setContent(data.data[1].OpenDonations)
        console.log(data.data)
    }

    useEffect(() => {
        fetchPendidikan()
    }, [])

    return (
        <div>
            <Nav2 />
            <BannerPendidikan />
            <div className="title-category">
                <div className="pendidikan">
                    {
                        content && content.map((c) => (
                            <Content
                                key={c.id}
                                name={c.donationName}
                                need={c.donationNeeded}
                                expired={c.expiredDate}
                                image={c.image}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Pendidikan;
